<div class="subcomponent-inner-wrap">
	<mat-card class="acies-card print-card">
		<mat-card-content>
			<router-outlet></router-outlet>
		</mat-card-content>
	</mat-card>
</div>
